<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('ParallelChannelTool', function() {
            return {
                group: 'Lines', category: 'Channels', icon: this.getIcon('channel'),
                name: 'Parallel Channel',
                type: 'Channel',
                hint: 'Parallel Channel',
                data: [],
                settings: {},
                mods: {
                    'Extended': {
                        settings: { extended: true, extendLeft: true, extendRight: true },
                        category: 'Channels',
                        icon: this.getIcon('channel'),
                        hint: 'Extended Parallel Channel',
                        name: 'Extended Channel'
                    }
                }
            }
        }, 'Parallel Channel')
</script>
